export const useIsMacOs = () => {
  return [window.navigator.platform.match(/^Mac/) || window.navigator.platform.match(/^iPhone/)];
};
